import React, { useCallback, useContext, useState } from 'react'
import { TableToolbarStyles } from './Style'
import { IconButtonGroup } from 'components/Form'
import { ReactComponent as NotificationIcon } from 'assets/icons/Notification.svg';
import { ReactComponent as NumbersIcon } from 'assets/icons/Numbers.svg';
import { ReactComponent as ListIcon } from 'assets/icons/List.svg';
import { AssessmentsContext } from './AssessmentsContext';
import { mapValues } from 'lodash';

const TableToolbar = () => {
    const [selectedIndex, setSelectedIndex] = useState(2)
    const { viewCell, setViewCell } = useContext(AssessmentsContext)

    const toolbarActions = [
        { name: "label", icon: ListIcon },
        { name: "value", icon: NumbersIcon },
        { name: "icon", icon: NotificationIcon }
    ]

    const changeViewType = useCallback((index) => {
        setSelectedIndex(index)
        const nViewCell = mapValues(viewCell, () => toolbarActions[index].name);
        setViewCell(nViewCell)
    }, [viewCell])

    return (
        <TableToolbarStyles>
            <div className='default-view'>
                {"ברירת מחדל"}
            </div>
            <div className='view-types'>
                {toolbarActions.map((act, index) =>
                    <IconButtonGroup
                        selected={index == selectedIndex}
                        icon={act.icon}
                        action={() => changeViewType(index)}
                        iconSize={{
                            width: 20,
                            height: 20
                        }}
                    />
                )}
            </div>
        </TableToolbarStyles>
    )
}

export default TableToolbar